import * as React from "react";
import { Icon } from "../../icon/icon/icon.mjs";
class TimelineItem extends React.Component {
  constructor() {
    super(...arguments);
    this.getIcon = () => {
      const { state } = this.props;
      switch (state) {
        case "warning":
          return "#alert";
        default:
          return "#check-round";
      }
    };
  }
  BEM() {
    const classArray = ["timeline__entry"];
    if (this.props.state === "warning") {
      classArray.push("has-warning");
    }
    if (this.props.state === "current") {
      classArray.push("is-current");
    }
    if (this.props.state === "done") {
      classArray.push("is-done");
    }
    return classArray.join(" ");
  }
  render() {
    const { children } = this.props;
    return /* @__PURE__ */ React.createElement("article", { className: this.BEM() }, /* @__PURE__ */ React.createElement(Icon, { modifiers: this.getIcon(), className: "timeline__icon", size: "xxs" }), /* @__PURE__ */ React.createElement("div", { className: "timeline__content" }, children));
  }
}
export {
  TimelineItem
};
